const features = [
  {
    icon: 'ri-shield-check-line',
    title: '严格保密',
    desc: '所有咨询采用端到端加密，无需实名，您的隐私是我们最重要的底线。',
  },
  {
    icon: 'ri-user-star-line',
    title: '持证顾问',
    desc: '所有顾问均持有国家级专业资质，平均15年以上临床咨询经验。',
  },
  {
    icon: 'ri-phone-line',
    title: '灵活方式',
    desc: '支持视频、语音、文字三种咨询方式，随时随地获得专业帮助。',
  },
  {
    icon: 'ri-heart-2-line',
    title: '温暖陪伴',
    desc: '不是冷冰冰的诊断，而是有温度的陪伴，让每一次咨询都充满安全感。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            我们深知谈论两性话题需要勇气，因此打造了一个让您完全安心的专业服务平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="p-6 rounded-xl bg-background-50 border border-background-200/50 text-center"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}